var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.priceContainerClass }, [
    _c("span", { staticClass: "price--regular" }, [
      _vm._v(
        _vm._s(
          _vm._f("currencyFilter")(
            _vm.price.regularPrice,
            _vm.currencyLocale,
            _vm.currencyCode
          )
        )
      )
    ]),
    _vm._v(" \n  "),
    _c("span", { staticClass: "price--sale" }, [
      _vm._v(
        _vm._s(
          _vm._f("currencyFilter")(
            _vm.price.salePrice,
            _vm.currencyLocale,
            _vm.currencyCode
          )
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }